export enum AlertTypeEnum {
  ScanBadBarcode = 1,
  IncorrectModality = 2,
  MissingPractitioner = 3,
  ImportToNonActiveSurvey = 4,
  TooManyResponsesImport = 5,
  ImportResponseOutOfRange = 6,
  MissingPrimaryContact = 7,
  ResponsesReceived50Per = 8,
  ImportInvalidDate = 9,
  ImportInvalidNumber = 10,
}

export type TAlertTypeEnum = keyof typeof AlertTypeEnum;

export const ALERT_TYPE_DESCRIPTION = {
  [AlertTypeEnum.ScanBadBarcode]: "Scan Bad Barcode",
  [AlertTypeEnum.IncorrectModality]: "Incorrect Modality",
  [AlertTypeEnum.MissingPractitioner]: "Missing Practitioner",
  [AlertTypeEnum.ImportToNonActiveSurvey]: "Import To Non-Active Survey",
  [AlertTypeEnum.TooManyResponsesImport]: "Too Many Responses Import",
  [AlertTypeEnum.ImportResponseOutOfRange]: "Import Response Out Of Range",
  [AlertTypeEnum.MissingPrimaryContact]: "Missing Primary Contact",
  [AlertTypeEnum.ResponsesReceived50Per]: "Responses Received Less Than 50 Percent",
  [AlertTypeEnum.ImportInvalidDate]: "Import Invalid Date",
  [AlertTypeEnum.ImportInvalidNumber]: "Import Invalid Number",
};
